import { notificationsByIdDeleteSlice } from './@async/delete';
import { notificationsByIdPatchSlice } from './@async/patch';

export const {
	requestDeleteNotificationsById,
	resetDeleteNotificationsById
} = notificationsByIdDeleteSlice.asyncActionCreators;

export const {
	requestPatchNotificationsById,
	resetPatchNotificationsById
} = notificationsByIdPatchSlice.asyncActionCreators;
